import styled from 'styled-components';

const FounderStyles = styled.div``;

export default FounderStyles;
